/**
 * US phone entry, matching Add staff: the input shows "(555) 123-4567" as
 * the user types and the API gets the 10 digits.
 */

/** A complete number as the input shows it. */
export const US_PHONE_PATTERN = /^\(\d{3}\) \d{3}-\d{4}$/;

/** The 10 national digits; a leading country code 1 ("+1 415 …") is dropped. */
export function usPhoneDigits(value: string | null | undefined): string {
  const digits = (value || '').replace(/\D/g, '');
  return (digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits).slice(0, 10);
}

/** "(555) 123-4567", or the partial form while it is being typed. */
export function formatUsPhone(value: string | null | undefined): string {
  const digits = usPhoneDigits(value);
  if (digits.length <= 3) return digits.length ? `(${digits}` : '';
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

/** A stored number for display: "(555) 123-4567" when it is a US number, else as stored. */
export function displayUsPhone(value: string | null | undefined): string {
  const raw = (value || '').replace(/\D/g, '');
  const isUs = raw.length === 10 || (raw.length === 11 && raw.startsWith('1'));
  return isUs ? formatUsPhone(raw) : (value ?? '');
}
